import type { Inline } from '@contentful/rich-text-types'
import type { ReactElement } from 'react'

import { ComponentContentTypes } from '@constants/enums/content-types'

import { ComponentLink } from '@components/component-link/component-link'
import { AssetImage } from '@components/contentful-content-types/asset-image/asset-image'
import { CtaButton } from '@components/cta/cta-button/cta-button'
import { ComponentCtaGroup } from '@components/cta/cta-group/cta-group'

type InlineEmbeddedEntryProps = Inline

export function InlineEmbeddedEntry(props: InlineEmbeddedEntryProps): ReactElement | null {
  switch (props.data?.target?.sys?.contentType?.sys?.id) {
    case ComponentContentTypes.ComponentLink: {
      return <ComponentLink category="unstyled" isEmbedded targetLink={props.data.target} />
    }
    case ComponentContentTypes.AssetImage: {
      return <AssetImage data={props.data.target} />
    }
    case ComponentContentTypes.ComponentCtaButton: {
      return <CtaButton data={props.data.target} inline={true} />
    }
    case ComponentContentTypes.ComponentCtaGroup: {
      return <ComponentCtaGroup data={props.data.target} inline={true} />
    }
  }

  return null
}
